import { AppLayoutContext } from 'Components/Templates/AppLayout/AppLayoutProvider';
import { useContext } from 'react';

export default function useNavbarItems() {
    const context = useContext(AppLayoutContext);

    if (!context) {
        throw new Error('useNavbarItems must be used within an AppLayoutProvider');
    }

    return context;
}
